import React, { FC, useState } from 'react';
import { Button, Dialog, DialogActions, FormControl, Grid, InputAdornment, MenuItem, TextField } from '@material-ui/core';
import { Check, Close, ExpandMore } from '@material-ui/icons';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useStyles } from '../../styles';
import { CustomDialogTitle, SelectControl } from '../../../../components';
import { ClientFilterType } from '../../IBDashboardModels';
import { PartnerPartnership } from '../../../../models';
import { useCommonStyles } from '../../../../styles';

export interface Props {
  open: boolean;
  currencies: string[];
  translation: any;
  partnerships: PartnerPartnership[];
  onClose: () => void;
  applyFilter: (partnership: string, currency: string, clientFilterType: ClientFilterType) => void;
}

export const FiltersDialog: FC<Props> = ({ open, currencies, partnerships, translation, onClose, applyFilter }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [selectedCurrency, setSelectedCurrency] = useState<string>('USD');
  const [selectedPartnership, setSelectedPartnership] = useState<string>('All');
  const [selectedClientFilterType, setSelectedClientFilterType] = useState<ClientFilterType>(ClientFilterType.All);

  const applyNewFilter = () => {
    applyFilter(selectedPartnership, selectedCurrency, selectedClientFilterType);
  };

  const clearFilter = () => {
    applyFilter('All', 'USD', ClientFilterType.All);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.filters} onClose={() => onClose()} />
      <Grid container direction="column">
        {partnerships && partnerships.length !== 0 && (
          <Grid item>
            <p className={commonClasses.formControlTitle}>{translation.text_6275}</p>
            <FormControl variant="outlined" className={commonClasses.formControl}>
              <SelectControl value={selectedPartnership} onChange={(event) => setSelectedPartnership(event.target.value)} minWidth={97}>
                <MenuItem className={commonClasses.optionSelector} value="All">
                  {translation.all}
                </MenuItem>
                {partnerships.map((partnership) => (
                  <MenuItem className={commonClasses.optionSelector} style={{ width: 'inherit' }} key={partnership.partnershipCode} value={partnership.partnershipCode}>
                    {partnership.partnershipCode}
                  </MenuItem>
                ))}
              </SelectControl>
            </FormControl>
          </Grid>
        )}
        {currencies.length !== 0 && (
          <Grid item style={{ marginTop: 10 }}>
            <p className={classes.currencyFormControlTitle}>{translation.text_6276}</p>
            <FormControl variant="outlined" className={commonClasses.formControl}>
              <TextField
                value={selectedCurrency}
                select
                onChange={(event) => setSelectedCurrency(event.target.value)}
                className={classes.selectContainer}
                InputProps={{
                  startAdornment: <InputAdornment position="start">{getSymbolFromCurrency(selectedCurrency)}</InputAdornment>,
                }}
                SelectProps={{
                  IconComponent: ExpandMore,
                }}
              >
                {currencies.map((currency) => (
                  <MenuItem className={commonClasses.optionSelector} key={currency} value={currency}>
                    {currency}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        )}
        <Grid item style={{ marginTop: 10 }}>
          <p className={classes.currencyFormControlTitle}>{translation.clients}</p>
          <FormControl variant="outlined" className={commonClasses.formControl}>
            <SelectControl value={selectedClientFilterType} onChange={(event) => setSelectedClientFilterType(event.target.value)}>
              <MenuItem className={commonClasses.optionSelector} key={ClientFilterType.All} value={ClientFilterType.All}>
                {translation.all}
              </MenuItem>
              <MenuItem className={commonClasses.optionSelector} key={ClientFilterType.Direct} value={ClientFilterType.Direct}>
                {translation.direct}
              </MenuItem>
              <MenuItem className={commonClasses.optionSelector} key={ClientFilterType.SubPartnership} value={ClientFilterType.SubPartnership}>
                {translation.sub_partnership}
              </MenuItem>
            </SelectControl>
          </FormControl>
        </Grid>
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={applyNewFilter} fullWidth startIcon={<Check />} className={commonClasses.activeDialogBtn}>
          {translation.text_65}
        </Button>
        <Button onClick={clearFilter} fullWidth startIcon={<Close />} className={commonClasses.cancelDialogBtn}>
          {translation.clearAll}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
